import React from "react";
import { SwitchProps } from "@mui/material";

const MuiSwitch: SwitchProps = {
  color: "primary",
};

export default MuiSwitch;
